<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      formPro: {
        direccionp: "",
        observaciones: "",
        fecha_productos: new Date(),
        state: true,
        id: 0,
      },
      detalleprodutos: [],
      title: "Compras",
      items: [
        {
          text: "Compras",
          href: "/",
        },
        {
          text: "Compras",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }

    this.detalle();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    showDate2(date) {
      return moment(date).locale("es").format("MMM Do YYYY");
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    detalle() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "productos/reporte_pdf?departamento=" +
            this.$route.params.departamento +
            "&estante=" +
            this.$route.params.estante,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.detalleprodutos = response.data.rows;
          console.log(response.data.rows);
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-9">
        <div class="row mb-3">
          <div class="col-xl-4 col-sm-6">
            <div class="mt-2">
              <h5></h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <h2 id="visor_imagenes">
            <span class="blanco-rojo">Productos por departamento</span>
          </h2>
          <div class="card-body">
            <div class="invoice-title">
              <!--   <div class="mb-4">
                <img
                  src="@/assets/images/logo-dark.png"
                  alt="logo"
                  height="20"
                /> 
              </div>-->
            </div>
            <hr />
            <div class="row"></div>
            <div class="row">
              <div class="col-6 mt-3">
                <address>
                  <strong>Empresa:</strong>
                  <br />Zona Auto <br />zonaauto@email.com<br />
                  San Marcos
                </address>
              </div>
              <div class="col-6 mt-3 text-sm-end">
                <address>
                  <strong>Fecha:</strong>
                  <br />{{ this.showDate2(this.formPro.fecha_productos) }}
                  <!-- <br />
                  <br />
                   -->
                </address>
              </div>
            </div>
            <div class="p-2 mt-3">
              <h3 class="font-size-16">Resumen de Orden</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Codigo</th>
                    <th>Producto y presentacion</th>
                    <th>Existencia</th>
                    <th>Precio compra</th>
                    <th>Precio venta</th>
                    <th>Proveedor</th>
                    <th>Ubicación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, idx) in this.detalleprodutos"
                    v-bind:key="idx"
                  >
                    <td>{{ idx + 1 }}</td>
                    <td>{{ item.Stock.codigo_stock }}</td>
                    <td>
                      {{ item.Stock.producto.nombre_producto }}
                      {{ item.Stock.presentacione.nombre_presentacion }}
                    </td>
                    <td>{{ item.Stock.existencia_stock }}</td>
                    <td>{{ money(item.Stock.precio_compra_stock) }}</td>
                    <td>{{ money(item.Stock.precio_venta_stock) }}</td>
                    <td>{{ item.Stock.proveedore.company_proveedor }}</td>
                    <td v-if="item.departamento">
                      {{ item.departamento.nombre_departamento }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <router-link
                  :to="{
                    name: 'productos',
                  }"
                  class="btn text-muted d-none d-sm-inline-block btn-dark"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Regresar
                </router-link>
              </div>
              <!-- end col -->

              <!-- end col -->
            </div>
            <div class="d-print-none">
              <div class="float-end">
                <a
                  href="javascript:window.print()"
                  class="btn btn-primary w-md waves-effect waves-light me-1"
                  ><i class="fa fa-print"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
